module.exports = __webpack_public_path__ + "static/media/mobile.abc65e05.png";